import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MedidoresService } from "../../servicios/medidores.service";
import { CatUbicacionMedidoresService } from "../../servicios/cat-ubicacion-medidores.service";
import { CatTipoMedidoresService } from "../../servicios/cat-tipo-medidores.service";
import { CatEstadoFuncionamientosService } from "../../servicios/cat-estado-funcionamientos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
//import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { AguasService } from "../../servicios/aguas.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Medidores } from "../../entidades/entidades";
import { CatUbicacionMedidores } from "../../entidades/entidades";
import { CatTipoMedidores } from "../../entidades/entidades";
import { CatEstadoFuncionamientos } from "../../entidades/entidades";
import { CatEstatus } from "../../entidades/entidades";
import { CatUsuarios } from "../../entidades/entidades";
//import { SolicitudDetalles } from "../../entidades/entidades";
import { Aguas } from "../../entidades/entidades";
import {RegistroBitacoraInput} from '../../entidades/entidades'
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';

@Component({
  selector: "app-medidores",
  templateUrl: "./medidores.component.html",
  styleUrls: ["./medidores.component.css"]
})
export class MedidoresComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catUbicacionMedidores: CatUbicacionMedidores[] = [];
  catTipoMedidores: CatTipoMedidores[] = [];
  catEstadoFuncionamientos: CatEstadoFuncionamientos[] = [];
  catEstatus: CatEstatus[] = [];
  catUsuarios: CatUsuarios[] = [];
  //solicitudDetalles: SolicitudDetalles[] = [];
  aguas: Aguas[] = [];
  medidoresForm: FormGroup;
  public registroBitacora = new RegistroBitacoraInput();
  @Input("medidores") medidores: Medidores;
  @Output("medidoresOutput") medidoresOutput: EventEmitter<Medidores>;

  constructor(
    private formBuilder: FormBuilder,
    private medidoresService: MedidoresService,
    private catUbicacionMedidoresService: CatUbicacionMedidoresService,
    private catTipoMedidoresService: CatTipoMedidoresService,
    private catEstadoFuncionamientosService: CatEstadoFuncionamientosService,
    private catEstatusService: CatEstatusService,
    private catUsuariosService: CatUsuariosService,
    //private solicitudDetallesService: SolicitudDetallesService,
    private aguasService: AguasService,
    private route: ActivatedRoute,
    private registroBitacoraService: RegistroBitacoraService

   
  ) {
    this.medidoresOutput = new EventEmitter();
  }

  ngOnInit() {
    this.getAllCatUbicacionMedidores();
    this.getAllCatTipoMedidores();
    this.getAllCatEstadoFuncionamientos();
    this.getAllCatEstatus();
    this.getAllCatUsuarios();
    //this.getAllSolicitudDetalles();
    //this.getAllAguas();
    this.medidoresForm = this.formBuilder.group({
      id: [undefined],
      serie: [undefined, [Validators.maxLength(20)]],
      idUbicacionMedidor: [undefined],
      idTipoMedidor: [undefined],
      idEstadoFuncionamiento: [undefined],
      idEstatus: [undefined],
      fechaIni: [undefined],
      fechaFin: [undefined],
      idUsuarioInstalo: [undefined],
      idSolicitudDetalle: [undefined],
      idAgua: [undefined]
    });
    if (this.medidores) this.medidoresForm.patchValue(this.medidores);
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async guardarMedidores() {
    try {
      if (this.medidoresForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      this.medidores = this.medidoresForm.value;

      if (this.medidores.id) {
        this.updateMedidores(this.medidores);
      } else {
        this.medidores.id = 0;
        await this.addMedidores(this.medidores);
        this.registroBitacora.idAgua;
        this.registroBitacora.idMovAsegurar = 1;
        this.registroBitacora.accion = "SE DIO DE ALTA UN NUEVO MEDIDOR/ CAMBIO DE MEDIDOR";
        const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
      }
      this.medidoresOutput.emit(this.medidores);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
              
      
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarMedidores");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addMedidores(medidores) {
    try {
      const datoretorno = await this.medidoresService
        .add(medidores)
        .toPromise();
      this.medidores = datoretorno;
      this.medidoresForm.patchValue(this.medidores);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addMedidores");
    }
  }

  async updateMedidores(medidores: Medidores) {
    
    try {
      const datoRetorno = await this.medidoresService
        .update(medidores)
        .toPromise();
     
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateMedidores");
    }
    
                  
    this.registroBitacora.idAgua;
    this.registroBitacora.idMovAsegurar = 1;
    this.registroBitacora.accion = "SE DIO DE ALTA UN NUEVO MEDIDOR/ CAMBIO DE MEDIDOR", this.medidores;
    const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
  }

  async deleteMedidores(medidores: Medidores) {
    try {
      const datoRetorno = await this.medidoresService
        .delete(medidores.id)
        .toPromise();
      this.getAllMedidores();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteMedidores");
    }
  }

  async getMedidores(id: number) {
    try {
      const datoRetorno = await this.medidoresService.getSingle(id).toPromise();
      this.medidoresForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getMedidores");
    }
  }

  async getAllMedidores() {
    try {
      const datoRetorno = await this.medidoresService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllMedidores");
    }
  }

  async getAllCatUbicacionMedidores() {
    try {
      const datoRetorno = await this.catUbicacionMedidoresService
        .getAll()
        .toPromise();
      this.catUbicacionMedidores = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUbicacionMedidores");
    }
  }

  async getAllCatTipoMedidores() {
    try {
      const datoRetorno = await this.catTipoMedidoresService
        .getAll()
        .toPromise();
      this.catTipoMedidores = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoMedidores");
    }
  }

  async getAllCatEstadoFuncionamientos() {
    try {
      const datoRetorno = await this.catEstadoFuncionamientosService
        .getAll()
        .toPromise();
      this.catEstadoFuncionamientos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstadoFuncionamientos");
    }
  }

  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

  async getAllCatUsuarios() {
    try {
      const datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.catUsuarios = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
    }
  }

  // async getAllSolicitudDetalles() {
  //   try {
  //     const datoRetorno = await this.solicitudDetallesService
  //       .getAll()
  //       .toPromise();
  //     this.solicitudDetalles = datoRetorno;
  //   } catch (e) {
  //     if (e.response) throw { message: e.response.data };
  //     else throw e;
  //   } finally {
  //     console.log("Paso por getSolicitudDetalles");
  //   }
  // }

  async getAllAguas() {
    try {
      const datoRetorno = await this.aguasService.getAll().toPromise();
      this.aguas = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAguas");
    }
  }
}
